// YOSHI-10464: sections of the developer portal, in reading order. The route is the contract of the
// sidebar and of every in-page link, so a section is added here and nowhere else.

import { DocsNavItem } from "../interfaces";

export const DOCS_BASE_ROUTE: string = "/docs";

export const DOCS_NAV_ITEMS: DocsNavItem[] = [
  { to: "/docs", translationKey: "overview" },
  { to: "/docs/quickstart", translationKey: "quickstart" },
  { to: "/docs/authentication", translationKey: "authentication" },
  { to: "/docs/endpoints", translationKey: "endpoints" },
  { to: "/docs/errors", translationKey: "errors" },
  { to: "/docs/glossary", translationKey: "glossary" },
  { to: "/docs/limits", translationKey: "limits" },
];
